function accessDeepObject(obj, keys) {
  if (!Array.isArray(keys) || typeof obj !== 'object') {
    throw new Error('accessDeepObject - obj or keys parameter of incorrect value');
  }

  try {
    return keys.reduce((a, b) => (a && a[b] ? a[b] : null), obj);
  } catch (err) {
    return null;
  }
}

export default {
  accessDeepObject,
};
